module.exports = __webpack_public_path__ + "img/downbac1.ee966038.png";